import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DownloadItem } from 'components/shared/DownloadPanel'

interface DownloadsState {
  downloads: DownloadItem[]
  autoDownload: boolean
}

const initialState: DownloadsState = {
  downloads: [],
  autoDownload: true,
}

const downloadsSlice = createSlice({
  name: 'downloads',
  initialState,
  reducers: {
    addDownload: (state, action: PayloadAction<DownloadItem>) => {
      state.downloads.push(action.payload)
    },
    updateDownload: (state, action: PayloadAction<{ id: string; updates: Partial<DownloadItem> }>) => {
      const index = state.downloads.findIndex(d => d.id === action.payload.id)
      if (index !== -1) {
        state.downloads[index] = { ...state.downloads[index], ...action.payload.updates }
      }
    },
    removeDownload: (state, action: PayloadAction<string>) => {
      state.downloads = state.downloads.filter(d => d.id !== action.payload)
    },
    setAutoDownload: (state, action: PayloadAction<boolean>) => {
      state.autoDownload = action.payload
    },
    clearDownloads: (state) => {
      state.downloads = []
    },
  },
})

export const {
  addDownload,
  updateDownload,
  removeDownload,
  setAutoDownload,
  clearDownloads,
} = downloadsSlice.actions

export default downloadsSlice.reducer
